import React from 'react';
import { useTranslation } from 'react-i18next';
import { AlertTriangle } from 'lucide-react';
import { cn } from '../lib/utils';
import type { CheckInRedo } from '../lib/guestApi';

/**
 * "Il check-in va rifatto": il motivo scelto dal gestore (tradotto) e la sua
 * nota, cosi' come l'ha scritta. Dentro i riquadri del check-in da fare
 * (Home, Il mio soggiorno, pagina Check-in).
 */
const CheckInRedoNote: React.FC<{ redo: CheckInRedo; className?: string }> = ({ redo, className }) => {
  const { t } = useTranslation();
  return (
    <div
      role="note"
      className={cn(
        'flex gap-2 rounded-xl border border-amber-300/70 bg-white/70 p-3 text-[13px] leading-snug text-stone-800',
        'dark:border-amber-500/40 dark:bg-stone-900/40 dark:text-stone-100',
        className,
      )}
    >
      <AlertTriangle className="mt-0.5 h-4 w-4 flex-shrink-0 text-amber-700 dark:text-amber-400" aria-hidden="true" />
      <div className="flex min-w-0 flex-col gap-1">
        <p className="m-0">
          <strong>{t('checkInRedo.reasonLabel')}:</strong> {t(`checkInRedo.reasons.${redo.reason}`)}
        </p>
        {redo.note ? (
          <p className="m-0 whitespace-pre-line break-words">
            <strong>{t('checkInRedo.noteLabel')}:</strong> {redo.note}
          </p>
        ) : null}
        <p className="m-0 text-[12.5px] text-stone-600 dark:text-stone-300">{t('checkInRedo.doorHidden')}</p>
      </div>
    </div>
  );
};

export default CheckInRedoNote;
